export const ADD_TO_TICKET_SYSTEM_BTN_ID = 'add-to-ticket-system-button';

export const JIRA_DESCRIPTION_PLATFORM = {
	WEB: 'web',
	MOBILE: 'mobile'
} as const;

export type JiraDescriptionPlatform =
	(typeof JIRA_DESCRIPTION_PLATFORM)[keyof typeof JIRA_DESCRIPTION_PLATFORM];
